import React from 'react';
import { Link } from 'react-router-dom';
import { FaLaptop, FaSearch, FaStar, FaShieldAlt } from 'react-icons/fa';
import { motion } from 'framer-motion';
import pcvazquezLogo from '../image/LOGO-V-blanco1.png'; // Asegúrate de tener el logo en esta ruta

const HeroWelcome = () => {
  return (
    <section className="relative flex min-h-[650px] items-center justify-center overflow-hidden bg-gradient-to-br from-[#0A2E38] via-[#072A32] to-[#051F26] pb-12 pt-28 md:min-h-[720px] md:pb-0 md:pt-32">
      {/* Efecto de partículas animadas - Reducidas en móviles */}
      {[...Array(10)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute rounded-full bg-[#B5EAD7] opacity-20 hidden sm:block"
          style={{
            width: Math.random() * 10 + 5,
            height: Math.random() * 10 + 5,
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
          }}
          animate={{
            y: [0, (Math.random() * 100) - 50],
            x: [0, (Math.random() * 60) - 30],
            opacity: [0.1, 0.3, 0.1],
          }}
          transition={{
            duration: Math.random() * 10 + 10,
            repeat: Infinity,
            repeatType: 'reverse',
          }}
        />
      ))}

      {/* Fondo con efecto parallax */}
      <motion.div 
        className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center opacity-10 mix-blend-soft-light"
        initial={{ scale: 1.2 }}
        animate={{ scale: 1 }}
        transition={{ duration: 10, repeat: Infinity, repeatType: 'reverse' }}
      />
      
      <div className="relative z-10 container mx-auto px-4 sm:px-6 text-center">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="max-w-6xl mx-auto"
        >
          <motion.p
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1, duration: 0.5 }}
            className="mx-auto mb-4 inline-flex rounded-full border border-[#83F4E9]/30 bg-white/5 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#83F4E9] backdrop-blur-sm"
          >
            Tecnología que te acompaña
          </motion.p>

          {/* Logo profesional - Imagen PCVASQUEZ */}
          <motion.div 
            className="mb-5 flex justify-center md:mb-6"
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="relative w-full max-w-xs md:max-w-md mx-auto">
              {/* Contenedor para la imagen del logo */}
              <div className="relative bg-gradient-to-br from-[#5E2B97]/20 to-[#C7A8FF]/20 p-4 md:p-6 rounded-xl md:rounded-2xl backdrop-blur-sm border border-[#7FDBFF]/30 shadow-lg md:shadow-2xl shadow-[#5E2B97]/20">
                {/* Imagen del logo PCVASQUEZ */}
                <div className="relative w-full mx-auto">
                  <img 
                    src={pcvazquezLogo}
                    alt="PCVASQUEZ Logo" 
                    className="w-full h-auto mx-auto brightness-110 contrast-110 drop-shadow-lg max-h-28 md:max-h-40 object-contain"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='120' viewBox='0 0 400 120'%3E%3Crect width='400' height='120' fill='%235E2B97'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial' font-size='32' fill='white'%3EPCVASQUEZ%3C/text%3E%3Ctext x='50%25' y='75%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial' font-size='16' fill='%23C7A8FF'%3ESOMOS TECNOLOGÍA%3C/text%3E%3C/svg%3E";
                    }}
                  />
                  {/* Efecto de brillo sobre la imagen */}
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/5 to-transparent mix-blend-overlay"></div>
                </div>
                
                {/* Línea decorativa */}
                <motion.div 
                  className="w-32 md:w-48 h-1 bg-gradient-to-r from-[#C7A8FF] to-[#7FDBFF] mx-auto mt-3 md:mt-4 rounded-full"
                  initial={{ scaleX: 0 }}
                  animate={{ scaleX: 1 }}
                  transition={{ delay: 0.8, duration: 1 }}
                />
              </div>
            </div>
          </motion.div>
          
          {/* Texto principal */}
          <motion.div 
            className="mb-7 md:mb-9"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.8 }}
          >
            <p className="text-lg sm:text-xl md:text-2xl text-[#7FDBFF] mb-4 md:mb-6 max-w-3xl mx-auto font-light leading-relaxed tracking-wide px-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              <span className="inline-block">
                EQUIPOS DE <span className="font-semibold text-[#FF9FF3]">ALTO RENDIMIENTO</span> PARA TODAS TUS
              </span>
              <br />
              <span className="inline-block">
                NECESIDADES <span className="font-semibold text-[#FF9FF3]">TECNOLÓGICAS</span>
              </span>
            </p>
          </motion.div>
          
          {/* Botón CTA */}
          <motion.div 
            className="mb-10 flex justify-center px-2 md:mb-14"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <motion.div
              whileHover={{ y: -5 }}
              whileTap={{ scale: 0.98 }}
              className="relative w-full max-w-xs sm:max-w-sm"
            >
              <div className="absolute inset-0 bg-[#FF9FF3] rounded-lg blur-md opacity-50 -z-10"></div>
              <Link 
                to="/products" 
                className="relative bg-gradient-to-br from-[#5E2B97] to-[#C7A8FF] hover:from-[#4B2280] hover:to-[#B597F5] text-white font-semibold py-3 md:py-4 px-6 md:px-10 rounded-lg text-base md:text-lg transition-all duration-300 shadow-xl hover:shadow-[0_20px_50px_rgba(94,43,151,0.4)] flex items-center justify-center group overflow-hidden uppercase tracking-wider w-full" 
                style={{ fontFamily: "'Montserrat', sans-serif", letterSpacing: '0.5px' }}
              >
                <span className="relative z-10 flex items-center">
                  <FaSearch className="mr-2 md:mr-3 group-hover:rotate-12 transition-transform" />
                  Descubrir Productos
                </span>
                <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 -rotate-45 scale-x-150"></span>
              </Link>
            </motion.div>
          </motion.div>

          {/* Tarjetas de beneficios */}
          <div className="mx-auto grid max-w-5xl grid-cols-1 gap-3 px-2 sm:grid-cols-2 sm:px-4 lg:grid-cols-3 md:gap-4">
            {[
              { 
                icon: <FaLaptop className="text-2xl md:text-3xl" />, 
                text: "TECNOLOGÍA DE ÚLTIMA GENERACIÓN", 
                gradient: "bg-gradient-to-r from-[#C7A8FF] to-[#B597F5]" 
              },
              { 
                icon: <FaShieldAlt className="text-2xl md:text-3xl" />, 
                text: "GARANTÍA EXTENDIDA", 
                gradient: "bg-gradient-to-r from-[#7FDBFF] to-[#6AC4E5]" 
              },
              { 
                icon: <FaStar className="text-2xl md:text-3xl" />, 
                text: "CALIDAD PREMIUM", 
                gradient: "bg-gradient-to-r from-[#5E2B97] to-[#4B2280]" 
              }
            ].map((item, index) => (
              <motion.div
                key={index}
                className={`${item.gradient} rounded-lg p-0.5 overflow-hidden`}
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.2 * index, duration: 0.5 }}
                whileHover={{ y: -5 }}
              >
                <div className="h-full rounded-[8px] bg-[#0A2E38]/90 p-4 backdrop-blur-sm md:rounded-[10px] md:p-4">
                  <div className={`text-3xl md:text-4xl mb-3 md:mb-4 ${item.gradient} text-transparent bg-clip-text flex justify-center`}>
                    {item.icon}
                  </div>
                  <p className="text-[#E0F7FA] font-medium uppercase text-xs md:text-sm tracking-wider leading-tight md:leading-normal" style={{ fontFamily: "'Montserrat', sans-serif" }}>{item.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>

      {/* Efecto de onda decorativo */}
      <div className="absolute bottom-0 left-0 right-0 h-24 md:h-40 overflow-hidden">
        <svg 
          viewBox="0 0 1200 120" 
          preserveAspectRatio="none" 
          className="absolute bottom-0 left-0 right-0 h-full w-full"
        >
          <path 
            d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" 
            fill="#5E2B97" 
            opacity="0.4"
          />
          <path 
            d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" 
            fill="#C7A8FF" 
            opacity="0.3"
          />
          <path 
            d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" 
            fill="#7FDBFF" 
            opacity="0.2"
          />
        </svg>
      </div>
    </section>
  );
};

export default HeroWelcome;
